import { Injectable } from '@angular/core';
import { MessagesService } from '../_services/messages.services';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';


@Injectable({
    providedIn: 'root'
})
export class MessagesManager {

    private _loading: BehaviorSubject<any> = new BehaviorSubject(false);
    private _messages: BehaviorSubject<any> = new BehaviorSubject(null);

    constructor(
        private messagesService: MessagesService,
        private router: Router,
    ) {

    }

    getLoading() {
        return this._loading.asObservable();
    }

    getListMessages() {
        return this._messages.asObservable();
    }

    getAllMessages() {
        this._loading.next(true);
        this.messagesService.getAllMessages().subscribe(rest => {
            this._loading.next(false);
            this._messages.next(rest);
        }, err => {
            this._loading.next(false);
        });
    }
}